/**
 * 模块 容器
 */
import React from 'react';
import cls from 'classnames';

import Item from './FormItem';
import styles from './index.module.scss';

type IProps = React.PropsWithChildren<{
  className?: string;
  title: string;
  extra?: React.ReactNode;
}>;

const Index: React.FC<IProps> = ({ className, title, children, extra }) => {
  return (
    <div className={cls(styles.contentBlock, className, 'content-block')}>
      <div className={cls(styles.blockHeader, 'content-block-header')}>
        <span className={styles.headerTitle}>{title}</span>
        <span className={styles.headerExtra}>{extra}</span>
      </div>
      <div className={cls(styles.blockBody, 'content-block-body')}>{children}</div>
    </div>
  );
};

export const FormItem = Item;

export default Index;
